<template>
  <div id="app-header">
    <section class="header-left">
      <div
        class="app-logo"
        @click="handleClickAppLogo"
        @dblclick="handleShowUserId"
      >
        <img src="/static/icon/qingmang-brand-logo.svg" alt="app-logo" />
      </div>
      <div class="line"></div>
      <template v-if="scope">
        <div class="name">
          <span>{{ publicationInfo.name }}</span>
        </div>
        <el-popover
          placement="bottom-start"
          popper-class="popper-scope-version"
          trigger="click"
        >
          <!-- 头部 已购买 -->
          <div v-if="scope.isBuy" slot="reference" class="version">
            {{ scope.isBuy.name }}
            <span v-if="scope.isExpiring">即将到期</span>
          </div>
          <!-- 头部 试用中 -->
          <div v-else slot="reference" class="version">
            <span>{{ scope.name }}</span>
            <span v-if="scope.isTry">试用中</span>
          </div>
          <!-- 已购买 -->
          <template v-if="scope.isBuy && !scope.isExpiring">
            <div class="duedate">
              <span>到期时间</span> {{ scope.isBuy.dueDate }}
            </div>
            <div
              class="updrage"
              v-if="pubType !== 'podcast'"
              @click="bindToUpdrage"
            >
              {{ scope.isBuy.isAdvanced ? '' : '升级和' }}续费
            </div>
          </template>
          <!-- 即将到期 -->
          <template v-else-if="scope.isBuy && scope.isExpiring">
            <div class="duedate">
              <span>到期时间</span> {{ scope.isBuy.dueDate }}
            </div>
            <div class="tip" v-if="scope.remainingDay < 1">
              试用中，将于今天到期。
            </div>
            <div class="tip" v-else>
              你的小程序将在
              {{ scope.remainingDay }}
              天后到期，届时小程序将无法访问，请尽快续费。
            </div>
            <div
              class="updrage"
              v-if="pubType !== 'podcast'"
              @click="bindToUpdrage"
            >
              {{ scope.isBuy.isAdvanced ? '' : '升级和' }}续费
            </div>
          </template>
          <!-- 试用中 -->
          <template v-else-if="scope.isTry">
            <div class="duedate">
              <span>试用中，剩余 {{ scope.remainingDay }} 天</span>
            </div>
            <div class="tip">试用结束后小程序将暂停访问。</div>
            <div
              class="updrage"
              v-if="pubType !== 'podcast'"
              @click="bindToUpdrage"
              >立即付费</div
            >
          </template>
          <!-- 其它 -->
          <template v-else>
            <div class="duedate"><span>到期时间</span> {{ scope.dueDate }}</div>
            <div
              class="updrage"
              v-if="scope.name !== '专业版'"
              @click="bindToUpdrage"
            >
              {{ scope.isAdvanced ? '' : '升级和' }}续费
            </div>
          </template>
        </el-popover>
      </template>
    </section>
    <section class="header-right">
      <!-- 首页 -->
      <div v-if="pubType === 'index'" class="container">
        <qm-button
          text="新建小程序"
          icon="add-white"
          @click.native="handleClickCreateApp"
        />
      </div>
      <!-- 品牌小程序 -->
      <div v-else-if="pubType === 'brand'" class="container">
        <BrandPublicationStatus />
      </div>
      <div v-else-if="pubType === 'podcast'" class="container">
        <PodcastPublicationStatus />
      </div>
      <!-- 反馈意见 -->
      <div class="container">
        <el-badge class="feedback">
          <span
            v-click-outside="handleClickFeedbackOutside"
            @click="bindFeedbackShow"
            >问题咨询</span
          >
          <div
            v-click-outside="handleClickFeedbackOutside"
            class="qm-card feedbackQr"
            :class="feedbackShow"
          >
            <div class="right">
              <img alt="问题咨询的二维码" src="/static/images/qrcode_qm.jpg" />
              <div class="tip">
                扫码咨询客服
              </div>
            </div>
          </div>
        </el-badge>
      </div>
      <!-- 完成帮助中心与通知 -->
      <div class="container icons">
        <!-- 临时放了一个反馈意见的入口，产品稳定之后会下掉 -->
        <el-badge class="help">
          <icon
            v-click-outside="handleClickOutside"
            name="help"
            @click.native="bindHelpShow"
          />
          <div
            v-click-outside="handleClickOutside"
            class="qm-card qr"
            :class="qrShow"
          >
            <div class="left">
              <div class="start">
                <div>教程与帮助</div>
                <div class="text">
                  <a
                    href="https://qingmang.zendesk.com/hc/zh-cn/articles/360019972152-%E8%BD%BB%E8%8A%92%E5%B0%8F%E7%A8%8B%E5%BA%8F-2-0%E5%8D%87%E7%BA%A7%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98"
                    target="_blank"
                    >轻芒小程序+ 2.0 升级常见问题</a
                  >
                  <a
                    href="https://qingmang.zendesk.com/hc/zh-cn/articles/360019464032-%E5%A6%82%E4%BD%95%E7%BB%99%E6%A0%8F%E7%9B%AE%E6%B7%BB%E5%8A%A0%E5%86%85%E5%AE%B9"
                    target="_blank"
                    >如何给栏目添加内容</a
                  >
                  <a
                    href="https://qingmang.zendesk.com/hc/zh-cn/articles/360019074711-%E5%85%AC%E4%BC%97%E5%8F%B7%E5%A6%82%E4%BD%95%E5%85%B3%E8%81%94%E5%B0%8F%E7%A8%8B%E5%BA%8F"
                    target="_blank"
                    >公众号如何关联小程序</a
                  >
                </div>
              </div>
              <a
                href="https://qingmang.zendesk.com/hc/zh-cn"
                target="_blank"
                class="end"
              >
                <div>去帮助中心</div>
                <img src="/static/icon/icon-right.svg" alt="icon-right" />
              </a>
            </div>
            <div class="right">
              <img src="/static/images/qrcode_qm.jpg" />
              <div class="tip">
                扫码联系客服
              </div>
            </div>
          </div>
        </el-badge>
        <!-- <el-badge>
          <img
            class="icon-img"
            src="/static/icon/icon-notice-notification-common.svg"
            alt="通知"
          >
        </el-badge>-->
      </div>
      <div class="container">
        <div class="user-logo">
          <img
            v-if="accountInfo.avatar"
            v-click-outside="handleClickOutside"
            alt="头像"
            :src="accountInfo.avatar"
            @click="bindHeadShow"
          />
        </div>
        <el-badge
          v-click-outside="handleClickOutside"
          class="headMore qm-card"
          :class="headShow"
        >
          <div class="row row1" @click="bindAccountEdit">
            <div>账号管理</div>
          </div>
          <div class="row row3" @click="bindExit">
            退出
          </div>
        </el-badge>
      </div>
    </section>
    <!-- 弹窗部分 -->
    <el-dialog
      v-if="createFormShow"
      :title="'新建' + createForm.displayPubType + '小程序'"
      :modal-append-to-body="false"
      :visible.sync="createFormShow"
    >
      <el-form :model="createForm" label-width="80px" @submit.native.prevent>
        <el-form-item prop="name" label="小程序名称">
          <el-input v-model="createForm.name" autofocus />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCreatePublicationClick">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import {createPublication} from 'src/api'
import {setCookie} from 'src/utils/utils'
import {mapGetters} from 'vuex'
import moment from 'moment'
import * as qm from 'src/utils/utils'
import * as api from 'src/api/index'
import BrandPublicationStatus from 'src/views/publication/BrandPublicationStatus.vue'
import PodcastPublicationStatus from 'src/views/publication/PodcastPublicationStatus.vue'
/* eslint-enable */
export default {
  components: {
    BrandPublicationStatus,
    PodcastPublicationStatus,
  },
  data() {
    return {
      pubTypeList: [
        {
          pubType: 'content',
          displayPubType: '内容呈现',
        },
        {
          pubType: 'group',
          displayPubType: '互动社群',
        },
        {
          pubType: 'quiz',
          displayPubType: '问答游戏',
        },
      ],
      createFormShow: false,
      createForm: {},

      appLogoTimer: undefined,
      qrShow: 'none',
      headShow: 'none',
      feedbackShow: 'none',
    }
  },
  computed: {
    pubType() {
      return this.$route.path.split('/')[1]
    },
    scope() {
      return this.publicationInfo.scope
    },
    publicationId() {
      return this.$route.params.publicationId
    },
    libId() {
      return this.$route.params.libId
    },
    magazineId() {
      return this.$route.params.magazineId
    },
    ...mapGetters({
      accountInfo: 'accountInfo',
      publicationInfo: 'publicationInfo',
      libInfo: 'libInfo',
      magazineConfig: 'magazineConfig',
    }),
  },
  methods: {
    bindToUpdrage() {
      this.$router.push(`/${this.pubType}/${this.publicationId}/upgrade`)
    },
    bindAccountEdit() {
      this.headShow = 'animate-fadeOut'
      this.$router.push('/profile')
    },
    bindExit() {
      qm.setCookie('readland', '', -1)
      // 旧的 cookie 一并删除
      qm.setCookie('readland', '', -1, '.readland.cn')
      this.$message.success(`退出成功`)
      setTimeout(() => {
        window.location.href = '/login'
      }, 1500)
    },
    handleTypeClick(type) {
      this.createForm = Object.assign({name: ''}, type)
      this.createFormShow = true
    },
    async handleCreatePublicationClick() {
      if (this.createForm.name === '') {
        this.$message.error('请输入小程序名称')
        return
      }
      const {name, pubType} = this.createForm
      try {
        const res = await createPublication(name, pubType)
        if (res.ok) {
          this.$message.success('创建成功')
          this.init()
        } else {
          throw new Error(res.error.desc)
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    handleClickCreateApp() {
      qm.GA('ui', 'opened_publication_type_panel', '')
      this.$router.push(`/create`)
    },
    handleClickAppLogo() {
      if (this.appLogoTimer) {
        clearTimeout(this.appLogoTimer)
        this.appLogoTimer = null
        return
      }
      this.appLogoTimer = setTimeout(() => {
        this.$router.push(`/index`)
        this.appLogoTimer = null
      }, 300)
    },
    handleShowUserId() {
      this.$confirm(`${this.accountInfo.uid}`, 'UID', {
        lockScroll: false,
        showCancelButton: false,
      })
    },
    handleClickOutside() {
      for (let e of ['qrShow', 'feedbackShow', 'headShow']) {
        if (this[e] === 'animate-fadeIn') {
          this[e] = 'animate-fadeOut'
        }
      }
    },
    bindHelpShow() {
      for (let e of ['feedbackShow', 'headShow']) {
        if (this[e] === 'animate-fadeIn') {
          this[e] = 'animate-fadeOut'
        }
      }
      if (this.qrShow === 'animate-fadeIn') {
        // 二维码已显示
      } else {
        qm.GA('ui', 'got_help', '')
        this.qrShow = 'animate-fadeIn'
      }
    },
    bindFeedbackShow() {
      for (let e of ['qrShow', 'headShow']) {
        if (this[e] === 'animate-fadeIn') {
          this[e] = 'animate-fadeOut'
        }
      }
      if (this.feedbackShow === 'animate-fadeIn') {
        // 二维码已显示
      } else {
        qm.GA('account', 'feedback', '')
        this.feedbackShow = 'animate-fadeIn'
      }
    },
    bindHeadShow() {
      for (let e of ['qrShow', 'feedbackShow']) {
        if (this[e] === 'animate-fadeIn') {
          this[e] = 'animate-fadeOut'
        }
      }
      if (this.headShow === 'animate-fadeIn') {
        // 二维码已显示
      } else {
        this.headShow = 'animate-fadeIn'
      }
    },
    handleClickFeedbackOutside() {
      if (this.feedbackShow === 'animate-fadeIn') {
        this.feedbackShow = 'animate-fadeOut'
      }
    },
  },
}
</script>

<style lang="scss">
.popper-scope-version {
  border-radius: 0 !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16) !important;
  padding: 16px !important;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  max-width: 250px;
  .duedate {
    color: #666;
    span {
      color: #333;
      font-weight: 600;
      margin-right: 10px;
      display: inline-block;
    }
  }
  .tip {
    margin-top: 12px;
    font-size: 14px;
    color: #666;
  }
  .updrage {
    cursor: pointer;
    margin-top: 16px;
    color: #0094ee;
    align-self: flex-end;
  }
}
#app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  font-size: 26px;
  color: #fff;

  .icon-help {
    color: #42505f;
    width: 24px;
    height: 24px;
  }

  .app-logo {
    padding: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      height: 24px;
      // width: 120px;
    }
  }
  .line {
    width: 1px;
    height: 20px;
    margin-right: 24px;
    margin-left: 4px;
    background: #eee;
  }
  .header-left {
    display: flex;
    align-items: center;
    padding: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    .icon {
      cursor: pointer;
      margin-left: 10px;
      opacity: 0.6;
    }
    .version {
      cursor: pointer;
      margin-left: 8px;
      font-size: 14px;
      color: #0094ee;
      font-weight: normal;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    padding: 0 8px;

    .container {
      position: relative;
      padding: 0 8px;
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      .el-badge {
        // height: 24px;
        & + .el-badge {
          margin-left: 26px;
        }
      }

      .help {
        cursor: pointer;
        position: relative;

        .qr {
          z-index: 10;
          cursor: auto;
          position: absolute;
          top: 48px;
          right: -60px;
          background: #fff;
          display: flex;
          font-size: 14px;
          height: 200px;

          a:hover {
            text-decoration: underline;
          }

          .left {
            padding: 24px;
            width: 311px;
            color: #000;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-right: 1px solid #eeefef;

            .start {
              font-weight: bold;

              .text {
                margin-top: 14px;
                color: #595656;
                font-weight: normal;

                a {
                  cursor: pointer;
                  display: block;
                }

                a + a {
                  margin-top: 8px;
                }
              }
            }

            .end {
              cursor: pointer;
              font-weight: bold;
              align-self: flex-end;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                margin-left: 4px;
              }
            }
          }

          .right {
            width: 160px;
            display: flex;
            align-items: center;
            flex-direction: column;

            img {
              margin-top: 20px;
              width: 120px;
              height: 120px;
            }

            .tip {
              margin-top: 19px;
              font-size: 14px;
              color: #000;
              font-weight: bold;
            }
          }
        }
      }
      .none {
        display: none !important;
      }
      .feedback {
        cursor: pointer;
        position: relative;
        color: #000000;
        font-size: 14px;
        line-height: 14px;
        height: 14px;
        font-weight: 500;
        .feedbackQr {
          z-index: 10;
          cursor: auto;
          position: absolute;
          top: 41px;
          right: -49px;
          background: #fff;
          display: flex;
          font-size: 14px;
          height: 200px;

          a:hover {
            text-decoration: underline;
          }

          .left {
            padding: 24px;
            width: 311px;
            color: #000;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-right: 1px solid #eeefef;

            .start {
              font-weight: bold;

              .text {
                margin-top: 14px;
                color: #595656;
                font-weight: normal;

                a {
                  cursor: pointer;
                  display: block;
                }

                a + a {
                  margin-top: 8px;
                }
              }
            }

            .end {
              cursor: pointer;
              font-weight: bold;
              align-self: flex-end;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                margin-left: 4px;
              }
            }
          }

          .right {
            width: 160px;
            display: flex;
            align-items: center;
            flex-direction: column;

            img {
              margin-top: 20px;
              width: 120px;
              height: 120px;
            }

            .tip {
              margin-top: 20px;
              font-size: 14px;
              color: #000;
              font-weight: bold;
            }
          }
        }
      }
      .head {
        position: relative;
      }

      .icon-img {
        width: 32px;
        height: 32px;
      }

      .user-logo {
        position: relative;
        cursor: pointer;
        width: 36px;
        height: 36px;
        img {
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }

      // & + .container:before {
      //   content: '';
      //   position: absolute;
      //   top: 50%;
      //   transform: translateY(-50%);
      //   left: 0;
      //   width: 1px;
      //   height: 20px;
      //   background-color: #dddddd;
      // }
    }
  }

  .headMore {
    position: absolute;
    z-index: 10;
    top: 48px;
    right: 18px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    width: 160px;
    background: #fff;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
    .row {
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 56px;
      padding: 0 24px;
    }
    .row3 {
      color: #d0021b;
    }
  }
}

// 动画
@keyframes animate-fadeOut {
  to {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes animate-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fadeOut {
  animation: animate-fadeOut 400ms ease forwards;
}

.animate-fadeIn {
  animation: animate-fadeIn 300ms ease forwards;
}
</style>
